import clsx from 'clsx';
import ArrowUpDashed from '@/assets/icons/arrow-up-dashed.svg?react';
import ArrowDownDashed from '@/assets/icons/arrow-down-dashed.svg?react';

interface Props {
  value: number;
  onChange: (value: number) => void;
  locked: boolean;
}

export const DigitInput = ({ value, onChange, locked }: Props) => {
  const handleIncrement = () => {
    if (locked) return;
    onChange((value + 1) % 10);
  };

  const handleDecrement = () => {
    if (locked) return;
    onChange(value === 0 ? 9 : value - 1);
  };

  return (
    <div className="flex flex-col items-center gap-2">
      <button
        onClick={handleIncrement}
        disabled={locked}
        className="w-8 h-6 flex items-center justify-center text-lg disabled:opacity-0 disabled:pointer-events-none cursor-pointer"
        aria-label="Increment"
      >
        <ArrowUpDashed />
      </button>

      <div
        className={clsx(
          'w-12 h-16 flex items-center justify-center text-2xl bg-transparent pointer-events-none select-none border-2',
          locked ? 'border-solid' : 'border-dashed',
        )}
      >
        {value}
      </div>

      <button
        onClick={handleDecrement}
        disabled={locked}
        className="w-8 h-6 flex items-center justify-center text-lg disabled:opacity-0 disabled:pointer-events-none cursor-pointer"
        aria-label="Decrement"
      >
        <ArrowDownDashed />
      </button>
    </div>
  );
};
